<template>
  <form @submit.prevent="addUser" class="add-friend-form">
    <h4 class="form__title">
      {{ $t('CP.addUser') }}
    </h4>
    <search-input
      @search="(search) => searchForUser(search)"
      class="form__search-input"
      :placeholder="$t('CP.enterPhoneNumber')"
    />
    <app-loader
      v-if="searchContactStatus === 'loading'"
      class="app-loader"
    />
    <add-friend-item
      class="friend-item"
      :no-user="searchContactStatus === 'error'"
      :user="searchContact"
      :phone="searchUserPhone"
      :error="isUserInContactList"
      :info-message="isUserInContactList ? $t('CP.userAlreadyAdded') : ''"
    />
    <create-user-form
      class="create-user-form"
      v-if="searchContactStatus === 'error'"
      :title="$t('CP.youCanCreate')"
      @contactCreated="createUser"
      @cancelSearch="cancelSearch"
      :phone="searchUserPhone"
    />
    <div class="form-buttons">
      <button-app
        class="form-button form-button_cancel"
        @clicked="cancelSearch"
        color-scheme="gray"
        type="button">
        {{ $t('CP.close') }}
      </button-app>
      <button-app
        class="form-button form-button_save"
        color-scheme="blue"
        @clicked="addUser"
        type="button"
        :disabled="isUserInContactList || !searchContact.uid"
      >
        {{ $t('CP.add') }}
      </button-app>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex';
import {
  SEARCH_CONTACT_REQUEST,
  CLEAR_SEARCH_CONTACT,
  // ADD_USER_CONTACT_REQUEST,
} from '@/store/user/types';
import SearchInput from '../../components/SearchInput/SearchInput';
import ButtonApp from '../../components/Button/ButtonApp';
import AddFriendItem from '../../components/AddFriendItem/AddFriendItem';
import AppLoader from '../../components/AppLoader/AppLoader';
import CreateUserForm from '../CreateUserForm/CreateUserForm';

export default {
  name: 'AddOutsiderUser',
  components: {
    CreateUserForm,
    AppLoader,
    AddFriendItem,
    ButtonApp,
    SearchInput,
  },
  props: {
    contactList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchUserPhone: '',
    };
  },
  computed: {
    ...mapState({
      searchContact: (state) => state.user.searchContact,
      searchContactStatus: (state) => state.user.searchContactStatus,
      user: (state) => state.user.user,
    }),
    isUserInContactList() {
      if (this.contactList && this.contactList.length
        && this.searchContact) {
        if (this.contactList
          .findIndex((contact) => (contact.uid === this.searchContact.uid)) !== -1) {
          return true;
        }
        if (this.searchContact.uid === this.user.user) return true;
      }
      return false;
    },
  },
  methods: {
    searchForUser(search) {
      this.$store.commit(CLEAR_SEARCH_CONTACT);
      this.searchUserPhone = search.replace(/\D/g, '');
      if (this.searchUserPhone.match(/^\+?\d\d?\d?\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{2})[- ]?(\d{2})$/)) {
        this.$store.dispatch(SEARCH_CONTACT_REQUEST,
          {
            phone: this.searchUserPhone,
            searchAll: true,
          });
      } else {
        this.$store.commit(CLEAR_SEARCH_CONTACT);
      }
    },
    cancelSearch() {
      this.$store.commit(CLEAR_SEARCH_CONTACT);
      this.$bvModal.hide('add-users-outside');
    },
    createUser(user) {
      this.$emit('addContact', user);
      this.$store.commit(CLEAR_SEARCH_CONTACT);
      this.$bvModal.hide('add-users-outside');
    },
    addUser() {
      const userPhone = this.searchUserPhone.match(/^\+?\d\d?\d?\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{2})[- ]?(\d{2})$/);
      if (userPhone && this.searchContact.uid) {
        // await this.$store.dispatch(ADD_USER_CONTACT_REQUEST,
        //   {
        //     contact: {
        //       name: this.searchContact.full_name,
        //       phone: this.searchUserPhone,
        //     },
        //   });
        [this.searchContact.phone] = userPhone;
        this.$emit('addContact', this.searchContact);
      }
      this.$store.commit(CLEAR_SEARCH_CONTACT);
      this.$bvModal.hide('add-users-outside');
    },
  },
};
</script>

<style lang="scss" scoped>
.form__title {
  color: var(--text-main-color);
  margin-bottom: 24px;
}

.form__search-input {
  margin-bottom: 32px;
}

.friend-item {
  margin-bottom: 32px;
}

.app-loader {
  margin: 20px auto;
  font-size: 6px;
}

.form-buttons {
  display: flex;
  flex: 1 0 50%;
  justify-content: center;
  margin: 22px 0 0 0;
}

.form-button {
  flex: 1;
  height: 38px;
  margin: 0;
}

.form-button_cancel {
  margin: 0 8px 0 0;
}

@media screen and (max-width: $breakpoint-sm) {
  .add-friend-form {
    padding-bottom: 60px;
  }
  .form-buttons {
    position: absolute;
    left: 16px;
    right: 32px;
    bottom: 16px;
  }
}
</style>
